/* eslint-disable import/no-restricted-paths */
import { APP_CONFIG } from 'shared/constants/common.constants';
import { ThemeData } from 'shared/interfaces/theme.interfaces';

const { useCurrentTheme } = !APP_CONFIG.IS_WEBAPP
  ? require('extension/context/theme.context') : require('webapp/src/contexts/theme.context');

export const useTheme = (): ThemeData => useCurrentTheme() as ThemeData;
